/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { FactionV5, FactionV5Interface } from "../FactionV5";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "assetsAddress",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MINTER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "assets",
    outputs: [
      {
        internalType: "contract IAssets",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "tokenID",
        type: "uint256",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "balances",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "baseURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    name: "byName",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "exists",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "getRoleMember",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleMemberCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "inventory",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
    ],
    name: "mint",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "names",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "onERC1155BatchReceived",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "onERC1155Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "prestige",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenOfOwnerByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "factionId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "transferInventory",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class FactionV5__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    assetsAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<FactionV5> {
    return super.deploy(assetsAddress, overrides || {}) as Promise<FactionV5>;
  }
  getDeployTransaction(
    assetsAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(assetsAddress, overrides || {});
  }
  attach(address: string): FactionV5 {
    return super.attach(address) as FactionV5;
  }
  connect(signer: Signer): FactionV5__factory {
    return super.connect(signer) as FactionV5__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): FactionV5Interface {
    return new utils.Interface(_abi) as FactionV5Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): FactionV5 {
    return new Contract(address, _abi, signerOrProvider) as FactionV5;
  }
}
